export const BRAND = {
  name: "모닝브루",
  nameEn: "MORNING BREW",
  slogan: "하루의 시작을 부드럽게 여는 한 잔",
  intro: "직접 로스팅한 싱글 오리진 원두와 매일 구운 빵으로 운영하는 스페셜티 카페입니다.",
  address: "서울특별시 마포구 연남동 223-14",
  phone: "02-333-8820",
  hours: "평일 08:00 - 22:00 · 주말 09:00 - 23:00",
};

export const NAV = [
  { id: "coffee", label: "COFFEE" },
  { id: "menu", label: "MENU" },
  { id: "rewards", label: "REWARDS" },
  { id: "store", label: "STORE" },
];

export const NOTICES = [
  { id: 1, title: "봄 시즌 메뉴 출시 안내", date: "2026.03.01" },
  { id: 2, title: "연남본점 리뉴얼 오픈", date: "2026.02.18" },
];

export const PROMO_SLIDES = [
  {
    id: 1,
    eyebrow: "Seasonal",
    title: "Spring Blossom Latte",
    desc: "벚꽃 시럽과 라벤더 노트가 어우러진 봄 한정 음료",
    cta: "자세히 보기",
    tone: "linear-gradient(135deg,#d4e8d4,#a8d5a2)",
    textTone: "dark",
  },
  {
    id: 2,
    eyebrow: "Reserve",
    title: "에티오피아 예가체프 리저브",
    desc: "소량 로스팅한 프리미엄 싱글 오리진 원두 출시",
    cta: "원두 보기",
    tone: "linear-gradient(135deg,#1e3932,#00704a)",
    textTone: "light",
  },
  {
    id: 3,
    eyebrow: "Food",
    title: "버터 크루아상 & 소금빵",
    desc: "매일 오전 7시 갓 구운 베이커리와 함께",
    cta: "푸드 메뉴",
    tone: "linear-gradient(135deg,#f5e6d3,#e8c9a8)",
    textTone: "dark",
  },
];

export const REWARDS = {
  title: "모닝브루 리워드",
  subtitle: "모닝브루만의 특별한 혜택",
  benefits: ["적립 · 무료 음료 쿠폰", "생일 쿠폰", "시즌 메뉴 우선 안내", "모바일 카드 간편 결제"],
};

export const PROMO_TILES = [
  {
    title: "리저브 원두 스토리",
    desc: "로스팅 스펙트럼과 싱글 오리진 이야기를 만나보세요.",
    cta: "커피 이야기",
    tone: "#1e3932",
  },
  {
    title: "가까운 매장 찾기",
    desc: "연남본점·홍대점·망원점 — 가장 가까운 모닝브루를 찾아보세요.",
    cta: "매장 찾기",
    tone: "#00704a",
  },
];

export const MENU_CATEGORIES = [
  { id: "drinks", label: "음료" },
  { id: "food", label: "푸드" },
  { id: "goods", label: "상품" },
];

export const MENU_DRINKS = [
  { name: "카페 아메리카노", price: "4,500원", cat: "브루드 커피", img: "americano" },
  { name: "카페 라떼", price: "5,500원", cat: "에스프레소", img: "latte" },
  { name: "콜드브루", price: "6,000원", cat: "콜드 브루", img: "coldbrew" },
  { name: "플랫 화이트", price: "5,800원", cat: "에스프레소", img: "flatwhite" },
  { name: "바닐라 라떼", price: "6,200원", cat: "에스프레소", img: "vanilla" },
  { name: "시그니처 블렌드", price: "5,000원", cat: "브루드 커피", img: "blend" },
];

export const MENU_FOOD = [
  { name: "버터 크루아상", price: "4,200원", cat: "브레드", img: "croissant" },
  { name: "통밀 소금빵", price: "3,800원", cat: "브레드", img: "saltbread" },
  { name: "레몬 파운드", price: "5,500원", cat: "케이크", img: "pound" },
  { name: "치아바타 샌드위치", price: "7,800원", cat: "샌드위치", img: "sandwich" },
];

export const MENU_GOODS = [
  { name: "모닝브루 텀블러", price: "28,000원", cat: "텀블러", img: "tumbler" },
  { name: "리저브 원두 200g", price: "18,000원", cat: "원두", img: "beans" },
  { name: "머그컵 세트", price: "32,000원", cat: "머그", img: "mug" },
  { name: "드립백 기프트", price: "24,000원", cat: "선물세트", img: "gift" },
];

export const STORES = [
  { name: "연남본점", addr: "마포구 연남동 223-14", hours: "08:00 - 22:00", type: "플래그십" },
  { name: "홍대점", addr: "마포구 양화로 160", hours: "09:00 - 23:00", type: "일반" },
  { name: "망원점", addr: "마포구 망원로 45", hours: "08:30 - 21:00", type: "테라스" },
];

export const FOOTER_LINKS = {
  service: ["자주 하는 질문", "고객의 소리", "이용 팁"],
  company: ["브랜드 소개", "채용 안내", "제휴 문의"],
  policy: ["개인정보처리방침", "이용약관", "위치정보 이용약관"],
};
